var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 3.125C23.9502 3.125 25 4.17432 25 5.46875C25 6.20605 24.6533 6.89941 24.0625 7.34375L13.4375 15.3125C12.8809 15.7275 12.1191 15.7275 11.5625 15.3125L0.9375 7.34375C0.347315 6.89941 0 6.20605 0 5.46875C0 4.17432 1.04932 3.125 2.34375 3.125H22.6562ZM10.625 16.5625C11.7383 17.3975 13.2617 17.3975 14.375 16.5625L25 8.59375V18.75C25 20.4736 23.5986 21.875 21.875 21.875H3.125C1.39893 21.875 0 20.4736 0 18.75V8.59375L10.625 16.5625Z",
    fill: "#FC6078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmtp);
export default __webpack_public_path__ + "static/media/smtp.20d5c1099e510f6f09e141e24620ccb8.svg";
export { ForwardRef as ReactComponent };